import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function AdminUsers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.admin.users().then(setRows).catch(() => {}); }, []);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-extrabold">Users</h1>
        <p className="text-gray-500 text-sm mt-1">{rows.length} registered learners</p>
      </div>
      <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr><th className="px-4 py-3 font-semibold">User</th><th className="px-4 py-3 font-semibold">Email</th><th className="px-4 py-3 font-semibold">Joined</th></tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map(r => (
              <tr key={r.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#6b47dc] to-[#ff5722] grid place-items-center text-white font-bold">{r.name[0]?.toUpperCase()}</div>
                    <div className="font-semibold">{r.name}</div>
                  </div>
                </td>
                <td className="px-4 py-3 text-gray-600">{r.email}</td>
                <td className="px-4 py-3 text-gray-500">{r.createdAt ? new Date(r.createdAt).toLocaleDateString() : '-'}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={3} className="text-center py-12 text-gray-400">No users yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
